/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "CardData": {
                "fields": {
                  "readerType": {
                    "type": ".squareup.client.bills.CardData.ReaderType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "keyedCard": {
                    "type": ".squareup.client.bills.CardData.KeyedCard",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unencryptedCard": {
                    "type": ".squareup.client.bills.CardData.UnencryptedCard",
                    "id": 3,
                    "rule": "optional"
                  },
                  "o1Card": {
                    "type": ".squareup.client.bills.CardData.O1Card",
                    "id": 4,
                    "rule": "optional"
                  },
                  "s1Card": {
                    "type": ".squareup.client.bills.CardData.S1Card",
                    "id": 5,
                    "rule": "optional"
                  },
                  "r4Card": {
                    "type": ".squareup.client.bills.CardData.R4Card",
                    "id": 6,
                    "rule": "optional"
                  },
                  "r6Card": {
                    "type": ".squareup.client.bills.CardData.R6Card",
                    "id": 7,
                    "rule": "optional"
                  },
                  "encryptedKeyedCard": {
                    "type": ".squareup.client.bills.CardData.EncryptedKeyedCard",
                    "id": 8,
                    "rule": "optional"
                  },
                  "a10Card": {
                    "type": ".squareup.client.bills.CardData.A10Card",
                    "id": 9,
                    "rule": "optional"
                  },
                  "r12Card": {
                    "type": ".squareup.client.bills.CardData.R12Card",
                    "id": 10,
                    "rule": "optional"
                  },
                  "x2Card": {
                    "type": ".squareup.client.bills.CardData.X2Card",
                    "id": 11,
                    "rule": "optional"
                  },
                  "mcrCard": {
                    "type": ".squareup.client.bills.CardData.MCRCard",
                    "id": 12,
                    "rule": "optional"
                  },
                  "t2Card": {
                    "type": ".squareup.client.bills.CardData.T2Card",
                    "id": 13,
                    "rule": "optional"
                  },
                  "serverCompleted": {
                    "type": ".squareup.client.bills.CardData.ServerCompleted",
                    "id": 14,
                    "rule": "optional"
                  },
                  "s3Card": {
                    "type": ".squareup.client.bills.CardData.S3Card",
                    "id": 15,
                    "rule": "optional"
                  },
                  "t3Card": {
                    "type": ".squareup.client.bills.CardData.T3Card",
                    "id": 16,
                    "rule": "optional"
                  },
                  "k1Card": {
                    "type": ".squareup.client.bills.CardData.K1Card",
                    "id": 17,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "KeyedCard": {
                    "fields": {
                      "expiry": {
                        "type": ".squareup.client.bills.CardData.KeyedCard.Expiry",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cvv": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "postalCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cardNumber": {
                        "type": "string",
                        "id": 1
                      },
                      "rawCardNumberUtf8": {
                        "type": "bytes",
                        "id": 5
                      }
                    },
                    "nested": {
                      "Expiry": {
                        "fields": {
                          "month": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "year": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "card_number_or_bytes": {
                        "oneof": ["cardNumber", "rawCardNumberUtf8"]
                      }
                    }
                  },
                  "UnencryptedCard": {
                    "fields": {
                      "track2Data": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "O1Card": {
                    "fields": {
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "S1Card": {
                    "fields": {
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "R4Card": {
                    "fields": {
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "R6Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "EncryptedKeyedCard": {
                    "fields": {
                      "encryptedKeyedCardData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "A10Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "entryMethod": {
                        "type": ".squareup.client.bills.CardData.A10Card.EntryMethod",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "EntryMethod": {
                        "values": {
                          "DEFAULT_DO_NOT_USE": 0,
                          "CONTACT": 1,
                          "CONTACTLESS": 2,
                          "SWIPED": 3
                        }
                      }
                    }
                  },
                  "R12Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedFelicaData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "X2Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "MCRCard": {
                    "fields": {
                      "plaintextReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "encryptedPinData": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      },
                      "encryptedReaderDataIv": {
                        "type": "bytes",
                        "id": 4,
                        "rule": "optional"
                      },
                      "encryptedPinDataIv": {
                        "type": "bytes",
                        "id": 5,
                        "rule": "optional"
                      },
                      "source": {
                        "type": ".squareup.client.bills.CardData.MCRCard.Source",
                        "id": 6,
                        "rule": "optional"
                      },
                      "pseudopan": {
                        "type": "bytes",
                        "id": 7,
                        "rule": "optional"
                      },
                      "hmacPin": {
                        "type": "bytes",
                        "id": 8,
                        "rule": "optional"
                      },
                      "hmacPan": {
                        "type": "bytes",
                        "id": 9,
                        "rule": "optional"
                      },
                      "flipperTicket": {
                        "type": "bytes",
                        "id": 10,
                        "rule": "optional"
                      },
                      "msNonce": {
                        "type": "int64",
                        "id": 11,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Source": {
                        "values": {
                          "MCR": 0,
                          "VCR": 1
                        }
                      }
                    }
                  },
                  "T2Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "S3Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "T3Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "encryptedSwipeData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "K1Card": {
                    "fields": {
                      "encryptedReaderData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ServerCompleted": {
                    "fields": {
                      "preauthIdempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "brand": {
                        "type": ".squareup.client.bills.CardData.ServerCompleted.ServerCompletedBrand",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ServerCompletedBrand": {
                        "values": {
                          "UNKNOWN_SERVER_COMPLETED_BRAND": 0,
                          "ALIPAY": 1,
                          "CASH_APP": 2,
                          "PAYPAY": 3,
                          "AFTERPAY": 4,
                          "RAKUTEN_PAY": 5,
                          "AU_PAY": 6,
                          "D_BARAI": 7,
                          "MERPAY": 8,
                          "WECHAT_PAY": 9
                        }
                      }
                    }
                  },
                  "ReaderType": {
                    "values": {
                      "UNKNOWN": 0,
                      "KEYED": 1,
                      "UNENCRYPTED": 2,
                      "O1": 3,
                      "S1": 4,
                      "R4": 5,
                      "R6": 6,
                      "ENCRYPTED_KEYED": 7,
                      "A10": 8,
                      "R12": 9,
                      "X2": 10,
                      "MCR": 11,
                      "T2": 12,
                      "SERVER_COMPLETED": 13,
                      "S3": 14,
                      "T3": 15,
                      "R41": 16,
                      "R42": 17,
                      "K1": 18
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.KeyedCard && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.KeyedCard?.nested?.Expiry && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.UnencryptedCard && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.O1Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.S1Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.R4Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.R6Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.EncryptedKeyedCard && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.A10Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.A10Card?.nested?.EntryMethod && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.R12Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.X2Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.MCRCard && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.MCRCard?.nested?.Source && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.T2Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.S3Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.T3Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.K1Card && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.ServerCompleted && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.ServerCompleted?.nested?.ServerCompletedBrand && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CardData?.nested?.ReaderType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardData @ squareup/client/bills/card_data.proto at 18:1
 */
export const CardData = $root.lookupType('squareup.client.bills.CardData');
fixType(CardData);
Builder.createAndAttachToType(CardData);
/**
 * SOURCE KeyedCard @ squareup/client/bills/card_data.proto at 19:3
 */
CardData.KeyedCard = $root.lookupType('squareup.client.bills.CardData.KeyedCard');
fixType(CardData.KeyedCard, {
  expiry: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.KeyedCard);
/**
 * SOURCE Expiry @ squareup/client/bills/card_data.proto at 28:5
 */
CardData.KeyedCard.Expiry = $root.lookupType('squareup.client.bills.CardData.KeyedCard.Expiry');
fixType(CardData.KeyedCard.Expiry, {
  month: {
    required: true
  },
  year: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.KeyedCard.Expiry);
/**
 * SOURCE UnencryptedCard @ squareup/client/bills/card_data.proto at 44:3
 */
CardData.UnencryptedCard = $root.lookupType('squareup.client.bills.CardData.UnencryptedCard');
fixType(CardData.UnencryptedCard, {
  track2Data: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.UnencryptedCard);
/**
 * SOURCE O1Card @ squareup/client/bills/card_data.proto at 49:3
 */
CardData.O1Card = $root.lookupType('squareup.client.bills.CardData.O1Card');
fixType(CardData.O1Card, {
  encryptedSwipeData: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.O1Card);
/**
 * SOURCE S1Card @ squareup/client/bills/card_data.proto at 54:3
 */
CardData.S1Card = $root.lookupType('squareup.client.bills.CardData.S1Card');
fixType(CardData.S1Card, {
  encryptedSwipeData: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.S1Card);
/**
 * SOURCE R4Card @ squareup/client/bills/card_data.proto at 59:3
 */
CardData.R4Card = $root.lookupType('squareup.client.bills.CardData.R4Card');
fixType(CardData.R4Card, {
  encryptedSwipeData: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.R4Card);
/**
 * At least one of encrypted_reader_data or encrypted_swipe_data fields must be set.
 *
 * SOURCE R6Card @ squareup/client/bills/card_data.proto at 75:3
 */
CardData.R6Card = $root.lookupType('squareup.client.bills.CardData.R6Card');
fixType(CardData.R6Card);
Builder.createAndAttachToType(CardData.R6Card);
/**
 * SOURCE EncryptedKeyedCard @ squareup/client/bills/card_data.proto at 83:3
 */
CardData.EncryptedKeyedCard = $root.lookupType('squareup.client.bills.CardData.EncryptedKeyedCard');
fixType(CardData.EncryptedKeyedCard, {
  encryptedKeyedCardData: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.EncryptedKeyedCard);
/**
 * SOURCE A10Card @ squareup/client/bills/card_data.proto at 89:3
 */
CardData.A10Card = $root.lookupType('squareup.client.bills.CardData.A10Card');
fixType(CardData.A10Card, {
  encryptedReaderData: {
    required: true
  },
  entryMethod: {
    required: true
  }
});
Builder.createAndAttachToType(CardData.A10Card);
/**
 * removed old ksn field id 2.
 * How a card was presented to A10 - dip, tap, or swipe.
 *
 * SOURCE EntryMethod @ squareup/client/bills/card_data.proto at 101:5
 */
CardData.A10Card.EntryMethod = $root.lookupEnum('squareup.client.bills.CardData.A10Card.EntryMethod').values;
/**
 * One of encrypted_reader_data or encrypted_felica_data fields must be set, but not both.
 *
 * SOURCE R12Card @ squareup/client/bills/card_data.proto at 113:3
 */
CardData.R12Card = $root.lookupType('squareup.client.bills.CardData.R12Card');
fixType(CardData.R12Card);
Builder.createAndAttachToType(CardData.R12Card);
/**
 * At least one of encrypted_reader_data or encrypted_swipe_data fields must be set.
 *
 * SOURCE X2Card @ squareup/client/bills/card_data.proto at 125:3
 */
CardData.X2Card = $root.lookupType('squareup.client.bills.CardData.X2Card');
fixType(CardData.X2Card);
Builder.createAndAttachToType(CardData.X2Card);
/**
 * SOURCE MCRCard @ squareup/client/bills/card_data.proto at 136:3
 */
CardData.MCRCard = $root.lookupType('squareup.client.bills.CardData.MCRCard');
fixType(CardData.MCRCard);
Builder.createAndAttachToType(CardData.MCRCard);
/**
 * SOURCE Source @ squareup/client/bills/card_data.proto at 158:5
 */
CardData.MCRCard.Source = $root.lookupEnum('squareup.client.bills.CardData.MCRCard.Source').values;
/**
 * At least one of encrypted_reader_data or encrypted_swipe_data fields must be set.
 *
 * SOURCE T2Card @ squareup/client/bills/card_data.proto at 183:3
 */
CardData.T2Card = $root.lookupType('squareup.client.bills.CardData.T2Card');
fixType(CardData.T2Card);
Builder.createAndAttachToType(CardData.T2Card);
/**
 * At least one of encrypted_reader_data or encrypted_swipe_data fields must be set.
 *
 * SOURCE S3Card @ squareup/client/bills/card_data.proto at 195:3
 */
CardData.S3Card = $root.lookupType('squareup.client.bills.CardData.S3Card');
fixType(CardData.S3Card);
Builder.createAndAttachToType(CardData.S3Card);
/**
 * At least one of encrypted_reader_data or encrypted_swipe_data fields must be set.
 *
 * SOURCE T3Card @ squareup/client/bills/card_data.proto at 207:3
 */
CardData.T3Card = $root.lookupType('squareup.client.bills.CardData.T3Card');
fixType(CardData.T3Card);
Builder.createAndAttachToType(CardData.T3Card);
/**
 * SOURCE K1Card @ squareup/client/bills/card_data.proto at 218:3
 */
CardData.K1Card = $root.lookupType('squareup.client.bills.CardData.K1Card');
fixType(CardData.K1Card);
Builder.createAndAttachToType(CardData.K1Card);
/**
 * Placeholder for server-completed tenders. Info about the payer will be filled in on the server.
 *
 * SOURCE ServerCompleted @ squareup/client/bills/card_data.proto at 226:3
 */
CardData.ServerCompleted = $root.lookupType('squareup.client.bills.CardData.ServerCompleted');
fixType(CardData.ServerCompleted);
Builder.createAndAttachToType(CardData.ServerCompleted);
/**
 * SOURCE ServerCompletedBrand @ squareup/client/bills/card_data.proto at 230:5
 */
CardData.ServerCompleted.ServerCompletedBrand = $root.lookupEnum('squareup.client.bills.CardData.ServerCompleted.ServerCompletedBrand').values;
/**
 * SOURCE ReaderType @ squareup/client/bills/card_data.proto at 249:3
 */
CardData.ReaderType = $root.lookupEnum('squareup.client.bills.CardData.ReaderType').values;